import React from 'react'

const Spinner = ({ size = 'small', color, className, ...props }) => {
    const sizeClass = `bimmatch-spinner-${size}`;
    const style = color ? { borderTopColor: color } : {};

    return (
        <div
            className={`bimmatch-spinner ${sizeClass} ${className || ''}`}
            style={style}
            {...props}
        ></div>
    )
}

export default Spinner